import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import strings from "../../core/translate";

const MerchantSubItemModalAddUpdate = ({
  code,
  description,
  loading,
  handleSubmit,
  changeInput,
  CardStyle,
}) => {
  return (
    <div className="content english">
      <Row>
        <Col md="12">
          <AvForm
            onValidSubmit={handleSubmit}
            className="form-horizontal"
            id="TypeValidation"
          >
            <Card style={CardStyle}>
              <CardHeader>
                <CardTitle tag="h4">{strings.information}</CardTitle>
              </CardHeader>
              <CardBody>
                <FormRow
                  label={strings.code}
                  name="code"
                  data={code}
                  changeInput={changeInput}
                />
                <FormRow
                  label={strings.description}
                  name="description"
                  data={description}
                  changeInput={changeInput}
                />
              </CardBody>
              <CardFooter className="text-center">
                <ButtonLoader color="primary" loading={loading}>
                  {strings.save}
                </ButtonLoader>
              </CardFooter>
            </Card>
          </AvForm>
        </Col>
      </Row>
    </div>
  );
};

export default MerchantSubItemModalAddUpdate;
